import styled from 'styled-components'

export const ButtonContainer = styled.div`
  padding-bottom: 15px;
`
